export const ComplaintStatus = {
  0: "Ubehandlet",
  1: "Under behandling",
  2: "Utført",
  3: "Avvist"
}
